import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SettingsComponent } from './settings.component';
import { FillableFieldsComponent } from './fillable-fields/fillable-fields.component';
import { ManageSubtypeComponent } from './manage-subtype/manage-subtype.component';
import { ManageTagsComponent } from './manage-tags/manage-tags.component';
import { AllNotificationsComponent } from './all-notifications/all-notifications.component';
import { ManageTransactionRolesComponent } from './manage-transactionroles/manage-transactionroles.component';
import { ManageIntegrationComponent } from './manage-integration/manage-integration.component';
import { ManageRoomComponent } from './manage-room/manage-room.component';
import { ManageEquipmentComponent } from './manage-equipment/manage-equipment.component';
import { ManageProcedureComponent } from './manage-procedure/manage-procedure.component';
import { ManageSupplyComponent } from './manage-supply/manage-supply.component';
import { ManageFacilityComponent } from './manage-facility/manage-facility.component';
import { AddFacilityRequestComponent } from './manage-facility/add-facility-request/add-facility-request.component';
import { ManageMonitoringComponent } from './monitoring/manage-monitoring/manage-monitoring.component';
import { ManageTemplateCategoryComponent } from './manage-templatecategory/manage-templatecategory.component';
import { ManageSharedRolesComponent } from './manage-sharedroles/manage-sharedroles.component';
import { ManageTemplatesComponent } from './manage-templates/manage-templates.component';
import { ImportComponent } from './import/import.component';
import { MessageTemplatesComponent } from './mesage-templates/message-templates.component';
import { LoginDetailsComponent } from './login-details/login-details.component';
import { ManageTaskStatusComponent } from './manage-taskstatus/manage-taskstatus.component';
import { ManageTaskTemplatesComponent } from './manage-tasktemplates/manage-tasktemplates.component';
import { ThirdPartyApiBindingComponent } from './third-party-api-binding/third-party-api-binding.component';
import { PaychexComponent } from './third-party-api-binding/paychex/paychex.component';
import { ManageTaskCategoryComponent } from './manage-taskcategory/manage-taskcategory.component';
import { AddThirdPartyComponent } from './add-third-party/add-third-party.component';
import { ManageTemplateCategoryOrgComponent } from './manage-templatecategoryorg/manage-templatecategoryorg.component';
import { ManageSingleTaskTemplatesComponent } from './manage-singletasktemplates/manage-singletasktemplates.component';
import { ManageActivityStatusComponent } from './manage-activitystatus/manage-activitystatus.component';
import { ManageOCRTemplateCategoryComponent } from './manage-OcrTemplatecategory/manage-OcrTemplatecategory.component';
import { ManageOCRTemplateComponent } from './manage-OcrTemplate/manage-OcrTemplate.component';
import { ManageEmailTemplateComponent } from './manage-Emailtemplate/manage-Emailtemplate.component';
import { ManageQuestionTemplateCategoryComponent } from './manage-QuestionTemplatecategory/manage-QuestionTemplatecategory.component';
import { ManageQuestionTemplateComponent } from './manage-QuestionTemplate/manage-QuestionTemplate.component';
import { ManageFolderFormComponent } from './manage-folderForm/manage-folderForm.component';
import { ManageFolderFormsComponent } from './manage-folderForms/manage-folderForms.component';
import { ManageCustomInfoStatusComponent } from './manage-customInfostatus/manage-customInfostatus.component';
import { ManageAIAutomationComponent } from './manage-AIAutomationTemplates/manage-AIAutomationTemplates.component';
import { ManageAutomationProcessReportComponent } from './manage-AutomationProcessReport/manage-AutomationProcessReport.component';
import { managentacomorbidityComponent } from './manage-nta-comorbidity/managentacomorbidity.component';
import { ManageSystemPromptsTemplateComponent } from './manage-Systemprompt/manage-Systemprompt.component';

const routes: Routes = [
  {
    path: '',
    component: SettingsComponent,
    children: [
      {
        path:'',
        component: FillableFieldsComponent,
      },
      {
        path:'subtype',
        component: ManageSubtypeComponent
      },
      {
        path:'managetag',
        component: ManageTagsComponent
      },
      {
        path:'managetransactionroles',
        component: ManageTransactionRolesComponent
      },
      {
        path:'manageintegration',
        component: ManageIntegrationComponent
      },
      {
        path:'notifications',
        component: AllNotificationsComponent
      },
      {
        path:'manageroom',
        component: ManageRoomComponent
      },
      {
        path:'manageequipment',
        component: ManageEquipmentComponent
      },
      {
        path:'manageprocedure',
        component: ManageProcedureComponent
      },
      {
        path:'managesupply',
        component: ManageSupplyComponent
      },
      {
        path:'managefacility',
        component: ManageFacilityComponent
      },
      {
        path:'facilityrequest',
        component: AddFacilityRequestComponent
      },
      { 
        path:'monitoring',
        component: ManageMonitoringComponent        
      },
      { 
        path:'templatecategory',
        component: ManageTemplateCategoryComponent        
      },
      { 
        path:'templatecategoryOrg',
        component: ManageTemplateCategoryOrgComponent        
      },
      { 
        path:'emailtemplate',
        component: ManageEmailTemplateComponent        
      },
      { 
        path:'managesharedrole',
        component: ManageSharedRolesComponent        
      },
      { 
        path:'managetemplates',
        component: ManageTemplatesComponent        
      },
      { 
        path:'managetasktemplates',
        component: ManageTaskTemplatesComponent        
      },
      { 
        path:'managesingletasktemplates',
        component: ManageSingleTaskTemplatesComponent        
      },
      { 
        path:'import',
        component: ImportComponent        
      },
      { 
        path:'messagetemplates',
        component: MessageTemplatesComponent        
      },
      { 
        path:'logindetails',
        component: LoginDetailsComponent        
      },
      {
        path:'managetaskstatus',
        component: ManageTaskStatusComponent
      },
      {
        path:'managefolderform',
        component: ManageFolderFormComponent
      },
      {
        path:'managefolderforms',
        component: ManageFolderFormsComponent
      },
      {
        path:'managentacomorbidity',
        component: managentacomorbidityComponent
      },
      {
        path:'systemprompts',
        component: ManageSystemPromptsTemplateComponent
      },
      {
        path:'manageactivitystatus',
        component: ManageActivityStatusComponent
      },
      {
        path:'managecustominfostatus',
        component: ManageCustomInfoStatusComponent
      },
      {
        path:'manageOcrTemplateCategory',
        component: ManageOCRTemplateCategoryComponent
      },
      {
        path:'manageQuestionTemplateCategory',
        component: ManageQuestionTemplateCategoryComponent
      },
      {
        path:'manageQuestionTemplate',
        component: ManageQuestionTemplateComponent
      },
      {
        path:'manageOcrTemplate',
        component: ManageOCRTemplateComponent
      },
      {
        path:'managetaskcategory',
        component: ManageTaskCategoryComponent
      },
      {
        path:'thirdparty',
        component: ThirdPartyApiBindingComponent
      },
      {
        path:'paychex',
        component: PaychexComponent
      },
      {
        path:'addthirdParty',
        component: AddThirdPartyComponent
      },
      {
        path:'manageAIAutomationTemplates',
        component: ManageAIAutomationComponent
      },
      {
        path:'manageAutomationProcessReport',
        component: ManageAutomationProcessReportComponent
      },
      
    ] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class settingRoutingModule { }
